import { NSARouterMakerResult } from "namirasoft-account-react";
import { FilterItem, FilterItemOperator } from "namirasoft-core";
import { NamirasoftPaymentMetaDatabase, ProductRow, SalesItemRow } from "namirasoft-payment";
import { IBaseComponentProps, NSCard, NSLoading, NSNoData, NSSection } from "namirasoft-site-react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PaymentLayout } from "../PaymentLayout";
import { PaymentProps } from "../PaymentProps";
import { PaymentRoutes } from "../PaymentRoutes";

interface SalesItemListPageProps extends NSARouterMakerResult, PaymentProps, IBaseComponentProps
{ }

interface SalesItemListPageState
{
	SalesItems: SalesItemRow[];
	product: ProductRow | null;
	isLoading: boolean;
}

export default function SalesItemListPage(props: SalesItemListPageProps)
{
	let params = useParams();
	let [state, setState] = useState<SalesItemListPageState>({ SalesItems: [], product: null, isLoading: true })

	useEffect(() =>
	{
		if (params.product_slug)
			loadProduct(params.product_slug);
		// eslint-disable-next-line react-hooks/exhaustive-deps 
	}, []);

	function loadProduct(slug: string)
	{
		let meta = new NamirasoftPaymentMetaDatabase(props.account.token_manager, props.notifier.onError);
		let filters = [
			new FilterItem(meta.tables.product, meta.tables.product.columns.slug, false, FilterItemOperator.all.equals, slug)
		];

		props.servers.payment.product.List(filters, null, null, [], null)
			.then((res) =>
			{
				let product: ProductRow | null = null;
				if (res.rows.length > 0)
					product = res.rows[0];

				setState(prevState => ({
					...prevState, product
				}));

				if (product != null)
					loadSalesItems(product.id);
			})
			.catch(() => { });
	}

	function loadSalesItems(product_id: string)
	{
		let meta = new NamirasoftPaymentMetaDatabase(props.account.token_manager, props.notifier.onError);
		let filters = [
			new FilterItem(meta.tables.sales_item, meta.tables.sales_item.columns.product_id, false, FilterItemOperator.all.equals, product_id)
		];

		props.servers.payment.sales_item.List(filters, null, null, [], null)
			.then((res) =>
			{
				setState(prevState => ({
					...prevState, SalesItems: res.rows, isLoading: false
				}));
			})
			.catch(() => { });
	}

	return (
		<PaymentLayout {...props}
			action={{
				description: "This section displays the items of a selected product that are available for sale."
			}}
		>
			<div
				id={props.id}
				className={`${"d-flex gap-3 flex-wrap justify-content-center container"} ${props.classList?.join(" ")}`}
				style={props.style}
			>
				{
					state.SalesItems.length !== 0 ?
						state.SalesItems.map((saleItem) =>
							<>
								<NSCard
									key={saleItem.id}
									link={{ href: PaymentRoutes.OfferList(state.product?.slug ?? "", saleItem.slug, true, ""), target: "_self" }}
									title={saleItem.name}
									image={{ src: saleItem.logo ?? '', alt: saleItem.name }} />
							</>
						)
						:
						<NSSection>
							{
								state.isLoading ? <NSLoading /> : <NSNoData classList={["p-3"]} lable='Currently, there are no data available. Please check back later for updates.' />
							}
						</NSSection>
				}
			</div>
		</PaymentLayout>
	);
}